import React from 'react';
import ReactDOM from 'react-dom/client';
import { StyledEngineProvider } from '@mui/material';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppContextProvider from './context/AppContext';

function AppRoot() {
  return (
    <StyledEngineProvider injectFirst>
      <AppContextProvider>
        <App />
      </AppContextProvider>
    </StyledEngineProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AppRoot />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
